import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import StoreRoutes from "./routes/StoreRoutes";
import AdminRoutes from "./routes/AdminRoutes";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        
        <Route path="/" element={<Navigate to="/store" replace />} />
        <Route path="/store/*" element={<StoreRoutes />} />
        <Route path="/administrator_jx677/*" element={<AdminRoutes />} />
        <Route path="*" element={<Navigate to="/store" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
